import React from 'react';
import {
  View,
  Platform,
} from 'react-native';
import {
  Button, Input,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';

import styles from '../../styles';
import { translate } from '../../locales/i18n';
import buttonPaypal from '../../assets/images/paypal.jpg';
import {
  emailValidation,
} from '../validation/User';

const validationSchema = yupObject().shape({
  email: emailValidation,
});

const countries = {
  AU: true,
  CA: true,
  IN: true,
  NZ: true,
  UK: true,
  US: true,
};
const currencies = {
  AUD: true,
  BRL: true,
  CAD: true,
  CZK: true,
  DKK: true,
  EUR: true,
  HKD: true,
  HUF: true,
  ILS: true,
  JPY: true,
  MYR: true,
  MXN: true,
  TWD: true,
  NZD: true,
  NOK: true,
  PHP: true,
  PLN: true,
  RUB: true,
  SGD: true,
  SEK: true,
  CHF: true,
  THB: true,
  GBP: true,
  USD: true,
};

const renderFormFunc = (_props, dismiss) => ({
  isValid,
  values,
  handleSubmit,
  setFieldValue,
  touched,
  errors,
  setFieldTouched,
  isSubmitting,
}) => {
  console.log('renderForm');

  return (
    <View
      style={{
        paddingTop: 10,
        flex: 1,
        justifyContent: 'space-evenly',
        alignItems: 'center',
        width: '100%',
        paddingHorizontal: 10,
      }}
    >
      <Input
        containerStyle={styles.form.inputContainer}
        labelStyle={styles.form.inputLabel}
        inputStyle={styles.form.inputInput}
        inputContainerStyle={styles.form.inputInputContainer}
        label={`${translate('revenue_method_paypal_email')}:`}
        value={values.email}
        placeholder={translate('revenue_method_paypal_email_hint')}
        // autoCapitalize="none"
        onChangeText={(value) => setFieldValue('email', value)}
        onBlur={() => setFieldTouched('email')}
        errorMessage={touched.email && errors.email ? errors.email : undefined}
        placeholderTextColor="grey"
      />
      <View style={{
        backgroundColor: 'white',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'row',
        marginTop: 40,
        ...(Platform.OS === 'ios' ? {
          paddingBottom: 10,
        } : {}),
      }}
      >
        {/* <Button
          title={translate('button_cancel')}
          containerStyle={styles.button.secondaryContainer}
          buttonStyle={styles.button.secondary}
          titleStyle={styles.button.secondaryTitle}
          onPress={dismiss}
        /> */}
        <Button
          title={translate('button_select')}
          containerStyle={styles.button.primaryContainer}
          buttonStyle={styles.button.primary}
          titleStyle={styles.button.primaryTitle}
          onPress={handleSubmit}
          loading={isSubmitting}
          disabled={!isValid}
          loadingProps={{ size: 'small', color: 'white' }}
        />
      </View>
    </View>
  );
};

export default {
  id: 'paypal',
  name: 'revenue_method_paypal',
  comment: 'revenue_method_paypal_comment',
  logo: buttonPaypal,
  configurable: true,
  available: (country, currency) => countries[country] && currencies[currency],
  configure: (dismiss, select) => (props, _context) => {
    const { userData } = props;

    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Formik
          style={{ flex: 1 }}
          initialValues={{
            email: userData.payoutPayPalEmail || '',
          }}
          enableReinitialize
          validateOnMount
          onSubmit={(values, _formikBag) => {
            select({
              payout: 'paypal',
              payoutPayPalEmail: values.email,
            });
          }}
          validationSchema={validationSchema}
        >
          {renderFormFunc(props, dismiss)}
        </Formik>
      </View>
    );
  },
};
